import script from "./NofiticationsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NofiticationsPopup.vue?vue&type=script&setup=true&lang=js"

import "./NofiticationsPopup.vue?vue&type=style&index=0&id=7e178a43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e178a43"]])

export default __exports__